module.exports = __webpack_public_path__ + "7829a4ba7b10dfe9b26c84b906c06855.svg";